import { formatValue, type Widget } from "../api";

export function Card({
  widget,
  mtd,
  company,
  previous,
  onClick,
  active,
}: {
  widget: Widget;
  /** Month-to-date value for the same entity filters. */
  mtd?: number | null;
  /** The unfiltered company total, shown for comparison while filtering. */
  company?: number | null;
  /** The same metric over the prior period, when a comparison is active. */
  previous?: number | null;
  /** Clicking the card toggles its trend chart below the KPI row. */
  onClick?: () => void;
  active?: boolean;
}) {
  const value = widget.value;
  const negative = (value ?? 0) < 0;

  const showDelta =
    previous !== undefined && previous !== null && value !== null && previous !== 0;
  const deltaPct = showDelta ? ((value! - previous!) / Math.abs(previous!)) * 100 : null;
  const up = (deltaPct ?? 0) >= 0;

  return (
    <div
      className={`card${onClick ? " clickable" : ""}${active ? " active" : ""}`}
      onClick={onClick}
      role={onClick ? "button" : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={onClick ? (e) => (e.key === "Enter" || e.key === " ") && onClick() : undefined}
      title={onClick ? "Show trend" : undefined}
    >
      <div className="card-title">
        {widget.title}
        {onClick && <span className="card-spark" aria-hidden="true">📈</span>}
      </div>
      <div className={`card-value${negative ? " negative" : ""}`}>
        {formatValue(value, widget.format, "short")}
      </div>

      <div className="card-meta">
        {mtd !== undefined && mtd !== null && (
          <span className="meta-item">
            MTD <b>{formatValue(mtd, widget.format, "short")}</b>
          </span>
        )}
        {deltaPct !== null ? (
          <span className={`meta-item delta ${up ? "up" : "down"}`}>
            {up ? "▲" : "▼"} {Math.abs(deltaPct).toFixed(1)}% vs prior
          </span>
        ) : (
          company !== undefined &&
          company !== null && (
            <span className="meta-item muted">
              Company <b>{formatValue(company, widget.format, "short")}</b>
            </span>
          )
        )}
      </div>
    </div>
  );
}
